import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';

import replaceText from '../../draft-js/modifiers/replaceText';

import { spellCheckRemoveSpelling, spellCheckBlock } from '../SpellCheck/actions';

import Spelling from '../../components/Spelling';

export class SpellingContainer extends React.PureComponent {
  static propTypes = {
    blockKey: PropTypes.string,
    draftBlockKey: PropTypes.string,
    children: PropTypes.node,
    suggestions: PropTypes.instanceOf(List),
    word: PropTypes.string,
    start: PropTypes.number,
    end: PropTypes.number,
    contentState: PropTypes.object,
    spellCheckRemoveSpelling: PropTypes.func,
    spellCheckBlock: PropTypes.func,
    handleContentStateChange: PropTypes.func,
  }

  state = {
    showSuggestions: false,
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.start !== this.props.start) {
      this.setState({ showSuggestions: false });
    }
  }

  handleClick = () => {
    this.setState({ showSuggestions: true });
  }

  handleClickOutside = () => {
    this.setState({ showSuggestions: false });
  }

  handleSuggestionClick = (suggestion) => {
    const newContentState = replaceText({
      contentState: this.props.contentState,
      key: this.props.draftBlockKey,
      start: this.props.start,
      end: this.props.end,
      text: suggestion,
    });

    this.props.handleContentStateChange(newContentState);
    this.props.spellCheckBlock(this.props.blockKey);
  }

  handleRemoveSpelling = () => {
    this.props.spellCheckRemoveSpelling(this.props.word, this.props.blockKey);
  }

  render() {
    return (
      <Spelling
        showSuggestions={this.state.showSuggestions}
        suggestions={this.props.suggestions}
        onClick={this.handleClick}
        onSuggestionClick={this.handleSuggestionClick}
        onRemoveSpelling={this.handleRemoveSpelling}
        onClickOutside={this.handleClickOutside}
      >
        {this.props.children}
      </Spelling>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    spellCheckRemoveSpelling: (word, blockKey) => {
      dispatch(spellCheckRemoveSpelling(word, blockKey));
    },
    spellCheckBlock: (blockKey) => {
      dispatch(spellCheckBlock(blockKey));
    },
  };
}

export default connect(null, mapDispatchToProps)(SpellingContainer);
